import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  GetCycleCountById,
  GetCycleCountResult,
  GetCycleCounts,
  GetCycleCountNumbers,
  GetPendingCycleCountRequests,
  UpdateCycleCount,
  UpdateCycleCountResult,
  ChangeCycleCountStatus,
  FactoryOptionsTobaccoTypes,
  GetConveyorSteps,
  BatchApplyActualQuantity,
  ApplyActualQuantity,
} from './thunks';

import {
  GetCycleCountsReducer,
  GetCycleCountNumbersReducer,
  ClearSelectedCycleCountReducer,
  GetCycleCountByIdReducer,
  UpdateCycleCountReducer,
  GetCycleCountResultByIdReducer,
  GetPendingCycleCountRequestsReducer,
  UpdateCycleCountResultReducer,
  ResetCycleCountStateReducer,
  ChangeCycleCountStatusReducer,
  FactoryOptionsTobaccoTypesReducer,
  GetConveyorStepsReducer,
  BatchApplyActualQuantityReducer,
  ApplyActualQuantityReducer,
} from './reducers';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'cycleCounts',
  initialState,
  reducers: {
    ClearSelectedCycleCount: ClearSelectedCycleCountReducer,
    ResetCycleCountState: ResetCycleCountStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetCycleCounts, GetCycleCountsReducer);
    addExtraReducer(builder, GetCycleCountNumbers, GetCycleCountNumbersReducer);
    addExtraReducer(builder, GetCycleCountById, GetCycleCountByIdReducer);
    addExtraReducer(builder, UpdateCycleCount, UpdateCycleCountReducer);
    addExtraReducer(builder, ChangeCycleCountStatus, ChangeCycleCountStatusReducer);
    addExtraReducer(builder, GetCycleCountResult, GetCycleCountResultByIdReducer);
    addExtraReducer(builder, GetPendingCycleCountRequests, GetPendingCycleCountRequestsReducer);
    addExtraReducer(builder, UpdateCycleCountResult, UpdateCycleCountResultReducer);
    addExtraReducer(builder, FactoryOptionsTobaccoTypes, FactoryOptionsTobaccoTypesReducer);
    addExtraReducer(builder, GetConveyorSteps, GetConveyorStepsReducer);
    addExtraReducer(builder, BatchApplyActualQuantity, BatchApplyActualQuantityReducer);
    addExtraReducer(builder, ApplyActualQuantity, ApplyActualQuantityReducer);
  },
});

export default slice.reducer;
